import * as React from "react";
import { Anchor } from "../typography/anchor/anchor.mjs";
import { Icon } from "../icon/icon/icon.mjs";
const Placeholder = (props) => {
  const { label, ...rest } = props;
  return /* @__PURE__ */ React.createElement(Anchor, { ...rest, className: "product-comparison__placeholder-link" }, /* @__PURE__ */ React.createElement("div", { className: "product-comparison__placeholder-link-inner" }, /* @__PURE__ */ React.createElement(Icon, { modifiers: "#plus", className: "product-comparison__placeholder-link-icon" }), /* @__PURE__ */ React.createElement("div", { className: "product-comparison__placeholder-link-label" }, label)));
};
export {
  Placeholder
};
